<template>
  <div>
    <b-card no-body class="shadow">
      <PaginatorTable responsive :fields="site_list_fields" :busy="rooms === null"
               :items="rooms" :sort-by="sort_by || default_sort_by" :hide-top-pagination="rooms.length < 25"
               :hide-filter="rooms.length < 10" :show_default_no_items_warning="false">
        <template v-slot:cell(name)="data">
          <b-link class="nowrap" :to="'/netdoc/sites/'+bldgs_by_nbr[data.item.bldg].site_fq_name+'/'+data.item.bldg+'/'+data.item.gpk"><b>{{ data.value }}</b></b-link>
        </template>
        <template v-slot:cell(number)="data">
          <b-link class="nowrap" :to="'/netdoc/sites/'+bldgs_by_nbr[data.item.bldg].site_fq_name+'/'+data.item.bldg+'/'+data.item.gpk"><b>{{ data.value }}</b></b-link>
        </template>
      </PaginatorTable>
      <div v-if="rooms && rooms.length === 0" class="font-italic text-center mb-3">
        {{ $t('components.bcd_list.no_rooms_available') }}
      </div>
    </b-card>
  </div>
</template>

<script>
import apiutil from '@/util/apiutil'
import PaginatorTable from '@/components/PaginatorTable.vue'

export default {
  name: 'RoomList',
  components: { PaginatorTable },
  watch: {
    filter: {
      immediate: true,
      async handler() {
        if (this.filter_callback !== null) {
          const result = await this.filter_callback(this.filter)
          if (result !== null) {
            this.filter = result
          }
        }
      }
    },
  },
  data() {
    return {
      filter: '',
      current_page: 1,
      per_page: 100,
      sort_by: null,
    }
  },
  computed: {
    bldgs_by_nbr() {
      return apiutil.dict_by_value_of_array(this.bldgs, 'number')
    },
    site_list_fields() {
      return [
        {
          label: this.$t('views.nd.room.floor'),
          key: 'floor',
          sortable: true
        },
        {
          label: this.$t('views.nd.room.number'),
          key: 'number',
          sortable: true
        },
        {
          label: this.$t('system.name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$t('system.description'),
          key: 'description',
          sortable: true
        },
      ]
    }
  },
  props: {
    default_sort_by: {
      required: false,
      default() {
        return 'number'
      }
    },
    rooms: {
      required: true,
      default() {
        return null
      }
    },
    bldgs: {
      required: true,
      default() {
        return null
      }
    },
    filter_callback: {
      required: false,
      default() {
        return null
      }
    },
  }
}
</script>

<style scoped>
</style>
